<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Email Content</h4>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="email-content" id="tour-email-header">
        <div class="md-layout">
          <div class="md-layout-item md-size-80">
            <h6 class="subhead">Email 1</h6>
          </div>
          <div class="md-layout-item md-size-20 text-right">
            <md-button
              v-if="canEdit"
              class="md-just-icon md-simple md-success"
              @click="
                editContent({
                  title: 'Email 1',
                  prop: 'email_header',
                  value: tour.email_header
                })
              "
            >
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="top">Edit</md-tooltip>
            </md-button>
          </div>
          <div class="md-layout-item md-size-100">
            <span class="email-content" v-html="tour.email_header"></span>
          </div>
        </div>
      </div>
      <div class="email-content" id="tour-email-footer">
        <div class="md-layout">
          <div class="md-layout-item md-size-80">
            <h6 class="subhead">Email 2</h6>
          </div>
          <div class="md-layout-item md-size-20 text-right">
            <md-button
              v-if="canEdit"
              class="md-just-icon md-simple md-success"
              @click="
                editContent({
                  title: 'Email 2',
                  prop: 'email_footer',
                  value: tour.email_footer
                })
              "
            >
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="top">Edit</md-tooltip>
            </md-button>
          </div>
          <div class="md-layout-item md-size-100">
            <span class="email-content" v-html="tour.email_footer"></span>
          </div>
        </div>
      </div>
    </md-card-content>
    <notes-dialog
      :showNotesDialog.sync="showDialog"
      :note="note"
      :title="dialogTitle"
      @saveNote="saveContent"
    />
  </md-card>
</template>

<script>
import tourApi from "@/services/api/tour";
import NotesDialog from "@/components/Handi/Notes/NotesDialog.vue";

export default {
  name: "TourTabsEmails",

  components: {
    NotesDialog
  },

  props: {
    tour: {
      type: Object,
      default: null
    }
  },

  computed: {
    canEdit() {
      return (
        this.$allowed(["tour.email.manage", "tour.email.update"]) ||
        (this.isSupplier && this.$allowed(["tour.update.own"]))
      );
    },
    isSupplier() {
      return this.tour.supplier.id == this.$store.state.auth.user.supplier.id;
    }
  },

  methods: {
    editContent(editableContent) {
      this.dialogTitle = editableContent.title;
      this.editableProp = editableContent.prop;
      this.note = { content: editableContent.value };
      this.showDialog = true;
    },
    saveContent(note) {
      this.tour[this.editableProp] = note.content;
      tourApi.updateTour(this.tour).then(() => {
        this.$notify({
          timeout: 2500,
          message: "Email Info has been updated.",
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });
      });
      this.showDialog = false;
    }
  },

  data() {
    return {
      showDialog: false,
      note: null,
      dialogTitle: null,
      editableProp: null
    };
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.email-content {
  border-bottom: 1px solid $brand-primary;
  margin-bottom: 2rem;

  h6.tagline,
  h6.subhead {
    margin: 0;
  }

  .md-button {
    margin: 0;
    padding: 5px;
    height: 27px;
    min-width: 27px;
    width: 27px;
    line-height: 27px;
  }
}
</style>
